// Données des cartes de visite digitales Pimp My Place.
// Le design est mutualisé : pour ajouter un mandataire, il suffit d'ajouter une entrée ici.
export const agents = {
  "mehdi-hachani": {
    slug: "mehdi-hachani",
    shortCode: "mh",
    firstName: "Mehdi",
    lastName: "Hachani",
    role: "Fondateur — Pimp My Place",
    tagline: "Trouver plus qu’un bien. Trouver votre chez-vous.",
    // photo: url du portrait professionnel. null = monogramme élégant affiché à la place.
    photo:
      "https://customer-assets-agu9un31.emergentagent.net/job_estate-portal-143/artifacts/nxra3pdn_PHOTO%20MEHDI%20VF1.png",
    phone: "+33756904327",
    phoneDisplay: "07 56 90 43 27",
    whatsapp: "33756904327",
    email: "contact@pimpmyplace.fr",
    website: "pimpmyplace.fr",
    area: "Basé dans le Vaucluse",
    // instagram: renseigner l'URL définitive pour afficher le bouton.
    instagram: null,
    // bookingUrl: URL Calendly ou équivalent. null = repli WhatsApp « Demander un rendez-vous ».
    bookingUrl: null,
    estimateUrl: "/estimation",
    specialties: ["Résidence principale", "Vente & estimation", "Premier achat", "Investissement"],
    whatsappMessages: {
      general:
        "Bonjour Mehdi, je vous contacte après avoir découvert Pimp My Place. J'aimerais échanger avec vous au sujet de mon projet immobilier.",
      buy: "Bonjour Mehdi, je recherche actuellement un bien immobilier et j'aimerais vous présenter mon projet.",
      invest:
        "Bonjour Mehdi, je souhaite échanger avec vous au sujet d'un projet d'investissement immobilier.",
      booking:
        "Bonjour Mehdi, je souhaiterais convenir d'un rendez-vous pour parler de mon projet immobilier.",
    },
    en: {
      role: "Founder — Pimp My Place",
      tagline: "More than a property. Your place to call home.",
      area: "Based in Provence · Vaucluse",
      specialties: ["Family homes", "Selling & valuation", "First purchase", "Investment"],
      whatsappMessages: {
        general:
          "Hello Mehdi, I found Pimp My Place and I would like to talk with you about my property project in Provence.",
        buy: "Hello Mehdi, I am looking for a property in Provence and I would like to tell you about my search.",
        invest: "Hello Mehdi, I would like to discuss a property investment project with you.",
        booking: "Hello Mehdi, I would like to book a call to discuss my property project.",
      },
    },
  },
};

export const getAgent = (slug) => agents[slug] || null;
